import classNames from "classnames";
import React from "react";

export interface ImageGalleryItem {
  name: string;
  src: string;
}

interface ImageGalleryProps {
  images: ImageGalleryItem[];

  maxHeight: number;

  className?: string;
}

const ImageGallery = ({ images, maxHeight, className }: ImageGalleryProps) => {
  return (
    <div className={classNames("image-gallery", className)}>
      {images.map((image) => (
        <img
          className="image-gallery__item"
          key={image.name}
          src={image.src}
          alt={image.name}
          style={{ maxHeight }}
        />
      ))}
    </div>
  );
};

export default ImageGallery;
